import { render, staticRenderFns } from "./refund1.vue?vue&type=template&id=0503853e&scoped=true"
import script from "./refund1.vue?vue&type=script&lang=js"
export * from "./refund1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0503853e",
  null
  
)

export default component.exports